exports.linkResolver = doc => {
  if (doc.type) {
    if (
      doc.type === 'subpage' ||
      doc.type === 'landing_page' ||
      doc.type === 'events_landing_page' ||
      doc.type === 'cme_events_landing_page' ||
      doc.type === 'audience_campaign_page'
    ) {
      return `/${doc.uid}/`
    }
    // ADVANCE
    if (doc.type === 'advance_landing_page') {
      return '/advance/'
    }
    if (doc.type === 'advance_article') {
      return `/advance/${doc.uid}/`
    }

    // MEDIA LIBRARY
    if (doc.type === 'media_library_page') {
      return '/watch-and-listen/'
    }
    if (doc.type === 'media_library_item') {
      return `/watch-and-listen/${doc.uid}/`
    }

    // CME MEDIA LIBRARY
    if (doc.type === 'cme_media_library_page') {
      return '/cme-library/'
    }
    if (doc.type === 'cme_media_library_item') {
      return `/cme-library/${doc.uid}/`
    }

    // Product Page
    if (doc.type === 'product_landing_page') {
      return '/seal-of-recognition/'
    }
    // Product Detail Page or Product Category Page
    if (doc.type === 'product' || doc.type === 'product_category') {
      return `/seal-of-recognition/${doc.uid}/`
    }

    // Authors / Staff
    if (doc.type === 'npf_author') {
      return `/staff/${doc.uid}/`
    }
    if (doc.type === 'staff__board_landing_page') {
      return `/leadership/${doc.uid}/`
    }

    // Resource Library
    if (doc.type === 'resource_library_page') {
      return '/resource-library/'
    }
    if (doc.type === 'resource_library_item') {
      return `/resource-library/${doc.uid}/`
    }

    // HCPD
    if (doc.type === 'hcpd_landing_page') {
      return '/health-care-provider-directory/'
    }
    if (doc.type === 'hcpd_login_page') {
      return '/health-care-provider-directory/login/'
    }
    if (doc.type === 'hcpd_reset_password_page') {
      return '/health-care-provider-directory/reset-password/'
    }
    if (doc.type === 'hcpd_new_registration_page') {
      return '/health-care-provider-directory/new-registration/'
    }
    if (doc.type === 'hcpd_confirm_registration_page') {
      return '/health-care-provider-directory/confirm-registration/'
    }
    if (doc.type === 'hcpd_edit_registration_page') {
      return '/health-care-provider-directory/edit-registration/'
    }
    if (doc.type === 'hcpd_thank_you_for_registering_page') {
      return '/health-care-provider-directory/thank-you-for-registering/'
    }
    if (doc.type === 'admin') {
      return `/admin/${doc.uid}/`
    }
    if (doc.type !== 'homepage') {
      return `${doc.uid}/`
    }
  }

  // Non-Prismic document links
  if (
    doc.link_type &&
    (doc.link_type === 'File' ||
      doc.link_type === 'Media' ||
      doc.link_type === 'Web')
  ) {
    return doc.url
  }

  return '/'
}
